export enum FacilityStatuses {
  ACTIVE = 'Active',
  INACTIVE = 'Inactive',
  PROBATION = 'Probation',
  PENDING = 'Pending',
  ACCOUNTING_HOLD = 'Accounting Hold',
  NEW_APPLICATION = 'New Application'
}
